<template>
    <div class="editOrderWrap"> 
        <div class="breadBox">
            <div class="breadItem"><span>订单管理</span></div>
            <div class="breadItem"><span>订单列表</span></div> 
            <div class="breadItem"><span>编辑订单（包工包料）</span></div>
        </div>
        <div class="content" v-loading="isloading"> 
            <div class="infoObjBox">
                 <el-button type="primary" @click="submitForm('ruleForm')">提交修改</el-button>
                <div class="row">
                    <p class="inlineBlock">
                        <span class="label">订单号：</span> 
                        <span class="text">{{orderNumber}}</span>
                    </p>
                    <p class="inlineBlock">
                        <span class="label">订单类型：</span> 
                        <span class="text">{{orderType |turnValToText("order_type")}}</span>
                    </p>
                    <p class="inlineBlock">
                         <span class="label">订单状态：</span> 
                        <span class="text">{{orderStatus |turnValToText("order_status")}}</span>
                    </p>
                </div>
                <div class="row">
                     <p class="inlineBlock">
                        <span class="label">发单方姓名：</span> 
                        <span class="text">{{fadanfangInfo.fadanfangInfo.company_name}}</span>
                    </p>
                    <p class="inlineBlock">
                         <span class="label">发单方ID：</span> 
                        <span class="text">{{fadanUserId}}</span>
                    </p>
                    <p class="inlineBlock">
                        <span class="label">注册手机号：</span> 
                        <span class="text">{{user_cellphone}}</span>
                    </p>
                </div>
                <div class="row">
                    <p class="inlineBlock">
                         <span class="label">联系人：</span> 
                        <span class="text">{{fadanfangInfo.fadanfangInfo.company_key_person}}</span>
                    </p>
                    <p class="inlineBlock">
                         <span class="label">联系电话：</span> 
                        <span class="text">{{fadanfangInfo.fadanfangInfo.company_key_person_phone}}</span>
                    </p>
                     <p class="inlineBlock">
                          <span class="label">公司电话：</span> 
                         <span class="text">{{fadanfangInfo.fadanfangInfo.company_phone}}</span>
                     </p>
                </div>
               
            </div>
            <!-- 表单内容 -->
            <div class="formWrap"  >
                <el-form :model="ruleForm" :inline="true" label-position="left" :rules="rules" ref="ruleForm"
                    label-width="190px" class="demo-ruleForm">
                    <el-form-item label="品牌" prop="orderBand" required >
                        <el-select v-model="ruleForm.orderBand" placeholder="请选择品牌">
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in brandWord"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="品质要求" prop="quantityStr" required>
                        <el-select v-model="ruleForm.quantityStr" placeholder="请选择品质要求">
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in quantityStrWord"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="大货交期" prop="orderDeliveryTime" required>
                        <el-date-picker value-format="yyyy/MM/dd" type="date" placeholder="选择日期" v-model="ruleForm.orderDeliveryTime" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <hr>
                    <el-form-item label="款式分类" prop="style1" class="block" required>
                        <el-select  v-model="ruleForm.style1" placeholder="请选择款式" @change="changeStyle(1,ruleForm.style1)">
                            <el-option :label="list_style.text" :value="list_style.value" v-for="(list_style,index) in styleWord1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="style2" class="block" required>
                        <el-select required v-model="ruleForm.style2" placeholder="请选择款式" @change="changeStyle(2,ruleForm.style2)">
                            <el-option :label="list_style.text" :value="list_style.value" v-for="(list_style,index) in styleWord2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="style3" class="block" required>
                        <el-select required v-model="ruleForm.style3" placeholder="请选择款式">
                            <el-option :label="list_style.text" :value="list_style.value" v-for="(list_style,index) in styleWord3"></el-option>
                        </el-select>
                    </el-form-item>
                    <hr>
                    <el-form-item label="样式图片" prop="name">
                        <div>
                            <div class="picUploadBox">
                                <span class="label"> <span class="errorStar">*</span> 正面全览图</span>
                                <div class="uploadBox">
                                    <div class="prevImgBox" v-for="(list_pImg,index) in positiveImgArr">
                                        <img  :src="list_pImg.image_file"  v-if="list_pImg.isAdd=='y'">
                                        <img  :src="IMG_PREV+list_pImg.image_file"   v-else>
                                        <i class="deleteIcon el-icon-delete" @click="deleteImg(index,positiveImgArr)"></i>
                                    </div>
                                    <el-upload v-if="positiveImgArr&&positiveImgArr.length==0" class="avatar-uploader"  :name="'files'" :data="uploadData" :action="api_app.baseUrl+'/file/uploadfilebatch'"  :on-success="addImgSuccessHandle"  :show-file-list="false" >
                                       <div class="uploadIconBox"  slot="trigger"  @click="addImgClick('zheng')"><i  class="el-icon-plus avatar-uploader-icon"></i></div>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="picUploadBox">
                                <span class="label">背面全览图</span>
                                <div class="uploadBox">
                                    <div class="prevImgBox" v-for="(list_pImg,index) in negativeImgArr">
                                        <img  :src="list_pImg.image_file" class="avatar" v-if="list_pImg.isAdd=='y'">
                                        <img  :src="IMG_PREV+list_pImg.image_file"  v-else>
                                        <i class="deleteIcon el-icon-delete" @click="deleteImg(index,negativeImgArr)"></i>
                                    </div>
                                    <el-upload v-if="negativeImgArr&&negativeImgArr.length==0" class="avatar-uploader"  :name="'files'" :data="uploadData"    :action="api_app.baseUrl+'/file/uploadfilebatch'"  :on-success="addImgSuccessHandle"  :show-file-list="false" >
                                       <div class="uploadIconBox"  slot="trigger"  @click="addImgClick('fan')"><i  class="el-icon-plus avatar-uploader-icon"></i></div>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="picUploadBox">
                                <span class="label">细节样式图</span>
                                <div class="uploadBox">
                                    <div class="prevImgBox" v-for="(list_pImg,index) in detailsImgArr">
                                        <img  :src="list_pImg.image_file" class="avatar" v-if="list_pImg.isAdd=='y'">
                                        <img  :src="IMG_PREV+list_pImg.image_file"  v-else>
                                        <i class="deleteIcon el-icon-delete"  @click="deleteImg(index,detailsImgArr)"></i>
                                    </div>
                                     <el-upload  class="avatar-uploader"  :name="'files'" :data="uploadData"    :action="api_app.baseUrl+'/file/uploadfilebatch'"  :on-success="addImgSuccessHandle"  :show-file-list="false" >
                                       <div class="uploadIconBox"  slot="trigger"  @click="addImgClick('detail')"><i  class="el-icon-plus avatar-uploader-icon"></i></div>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                        <div>
                            款式说明：<el-input v-model="ruleForm.styleDes" type="textarea"></el-input>
                        </div>
                    </el-form-item>
                    <hr>
                    <el-form-item v-if="!isAllowEditPrice" label="颜色尺码数量">
                         <div>
                           <el-select v-model="ruleForm.sizeType" placeholder="请选择尺码类型" @change="changeSizeType" disabled>
                                <el-option :label="list_s.text" :value="list_s.value" v-for="(list_s,index) in sizeTypeWord"></el-option>
                           </el-select>
                        </div>
                        <div>
                            <span  class="btnSpan" :class="{active:list.isSelect==1}"  v-for="list in currentSizeArr"> {{list.dataName}}</span> 
                        </div>
                        <ul>
                            <li class="colorGroupBox" v-for="(list,index) in  currentSizeGroup">
                                <div>颜色：{{list.color}}  小计：{{list.sum}}件</div>
                                <div v-for="list2 in list.sizeArr">
                                    <span>尺码： {{list2.name}} </span>
                                    <span> {{list2.number}} 件</span>
                                </div>
                            </li>
                             <li>
                                总数：{{ruleForm.orderQuantity}}
                            </li>
                        </ul>
                    </el-form-item >
                    <hr>
                    <el-form-item label="颜色-尺码-数量" prop="sizeType" required v-if="isAllowEditPrice"> 
                         <el-button @click="isShowSizeBlock=!isShowSizeBlock"  >
                            <i class="el-icon-caret-bottom" v-if="isShowSizeBlock">收起</i>
                            <i class="el-icon-caret-top" v-if="!isShowSizeBlock">展开</i>
                        </el-button>
                        <div v-if="isShowSizeBlock">
                            <div>
                               <el-select v-model="ruleForm.sizeType" placeholder="请选择尺码类型" @change="changeSizeType" >
                                    <el-option :label="list_s.text" :value="list_s.value" v-for="(list_s,index) in sizeTypeWord"></el-option>
                               </el-select>
                            </div>
                            <div>
                                <span class="btnSpan" :class="{active:list.isSelect==1}"  v-for="list in currentSizeArr" @click="toggleSelected(list,'sizeColor')"> {{list.dataName}}</span> 
                            
                            </div>
                            <ul>
                               
                                <li class="colorGroupBox" v-for="(list,index) in  currentSizeGroup">
                                    <div> <i class="deleteIcon el-icon-delete" @click="deleteColorGroup(index)"></i> 颜色：<el-input v-model="list.color" class="borderBottomInput"></el-input>小计：{{list.sum}}件</div>
                                    <div v-for="list2 in list.sizeArr">
                                        <span>尺码： {{list2.name}}</span>
                                        <el-input-number :min="0"  label="描述文字" v-model="list2.number"  @change="changeSizeNum(list)"></el-input-number> 件
                                    </div>
                                </li>
                                 <li class="colorGroupBox" v-if="currentSizeGroup&&currentSizeGroup.length>0" @click="addColorGroup">
                                    <el-button type="success">增加颜色</el-button>
                                    总数：{{ruleForm.orderQuantity}}
                                </li>
                            </ul>
                        </div>
                        
                    </el-form-item>
                    <hr>
                    <el-form-item label="意向单价"  prop="orderUnitPrice"  >
                         <div v-if="isAllowEditPrice">
                            <el-input @change="changeOrderUnitPrice" v-model="ruleForm.orderUnitPrice" class="borderBottomInput"></el-input> 元
                        </div>
                        <div v-if="!isAllowEditPrice">
                           {{ruleForm.orderUnitPrice}}元
                        </div>
                    </el-form-item>
                    <el-form-item label="意向总价" prop="resource">
                        {{orderTotalPrice}}元
                    </el-form-item>
                    <hr>
                    <el-form-item label="您可提供的资料(可多选)" prop="desc">
                        <span class="btnSpan" :class="{active:list.isSelect==1}" v-for="list in ruleForm.needInfomationObj&&ruleForm.needInfomationObj.list" @click="toggleSelected(list)">{{list.dataName}}</span>
                        <span class="inlineSpan">其他：</span>
                        <el-input v-model="ruleForm.needInfomationObj.other"></el-input>
                    </el-form-item>
                    <hr>
                    <hr>
                    <el-form-item label="面料信息" >
                        <el-button @click="isShowFabricBlock=!isShowFabricBlock"  >
                            <i class="el-icon-caret-bottom" v-if="isShowFabricBlock">收起</i>
                            <i class="el-icon-caret-top" v-if="!isShowFabricBlock">展开</i>
                        </el-button>
                        <div v-if="isShowFabricBlock">
                             <ul>
                                <li class="fabricGroup" v-for="(list,indexFabGroup) in ruleForm.fabricInformationStrObj&&ruleForm.fabricInformationStrObj.group" :key="indexFabGroup">
                                    <el-button class="rightPositionButton" @click="deleteFabricGroup(indexFabGroup)" v-if="indexFabGroup>0"><i class="el-icon-delete"></i></el-button>
                                    <div>
                                        面料名称 <el-input v-model="list.name" class="borderBottomInput" placeholder=""></el-input>
                                    </div>
                                    <div>
                                        是否指定供应商
                                        <el-radio v-model="list.nominatedSupplier" label="1">是</el-radio>
                                        <el-radio v-model="list.nominatedSupplier" label="0">否</el-radio>
                                    </div>
                                     <div>
                                        面料主成分
                                        <el-radio v-model="list.fabricMainRadio" label="1">选择面料</el-radio>
                                        <el-radio v-model="list.fabricMainRadio" label="0">自填</el-radio>
                                        <div style="padding: 10px 0 20px 60px;;">
                                            <div v-show="list.fabricMainRadio==1">
                                                <el-select v-model="list.fabricMainSelect" placeholder="请选择面料" >
                                                    <el-option :label="listFm.text" :value="listFm.value" v-for="(listFm,indexFm) in fabricMainWord" :key="indexFm"></el-option>
                                                </el-select>
                                            </div>
                                            <div v-show="list.fabricMainRadio==0">
                                                <el-input v-model="list.fabricMainEdit" class="borderBottomInput" placeholder="自填面料" ></el-input>
                                            </div>
                                            
                                        </div>
                                       
                                    </div>
                                    <div>
                                        面料克重 <el-input v-model="list.fabricGramWeight" class="borderBottomInput"></el-input>克/平方米
                                    </div>
                                    <div>
                                        是否需要复合 
                                        <el-radio v-model="list.recombination" label="1">是</el-radio>
                                        <el-radio v-model="list.recombination" label="0">否</el-radio>
                                    </div>
                                    <div>
                                        是否需要水洗
                                         <el-radio v-model="list.washing" label="1">是</el-radio>
                                        <el-radio v-model="list.washing" label="0">否</el-radio>
                                    </div>
                                    <div>
                                        是否需要缩水
                                         <el-radio v-model="list.shrink" label="1">是</el-radio>
                                        <el-radio v-model="list.shrink" label="0">否</el-radio>
                                    </div>
                                    <div>
                                        面料图片 
                                        <div class="uploadBox">
                                            <div class="prevImgBox" v-for="(list_fImg,index) in list.imageJson[0]&&list.imageJson[0].fabricImgs">
                                                <img  :src="list_fImg.image_file" class="avatar" v-if="list_fImg.isAdd=='y'">
                                                <img  :src="IMG_PREV+list_fImg.image_file"  v-else>
                                                <i class="deleteIcon el-icon-delete"  @click="deleteImg(index,list.imageJson[0].fabricImgs)"></i>
                                            </div>
                                             <el-upload  class="avatar-uploader"  :name="'files'" :data="uploadData"    :action="api_app.baseUrl+'/file/uploadfilebatch'"  :on-success="addImgSuccessHandle"  :show-file-list="false" >
                                               <div class="uploadIconBox"  slot="trigger"  @click="addImgClick('mianliao',list.imageJson[0].fabricImgs)"><i  class="el-icon-plus avatar-uploader-icon"></i></div>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <div>
                                        面料用料参数图片 
                                        <div class="uploadBox">
                                            <div class="prevImgBox" v-for="(list_fImg,index) in list.imageJson[0]&&list.imageJson[0].fabricParamImgs">
                                                <img  :src="list_fImg.image_file" class="avatar" v-if="list_fImg.isAdd=='y'">
                                                <img  :src="IMG_PREV+list_fImg.image_file"  v-else>
                                                <i class="deleteIcon el-icon-delete"  @click="deleteImg(index,list.imageJson[0].fabricParamImgs)"></i>
                                            </div>
                                             <el-upload  class="avatar-uploader"  :name="'files'" :data="uploadData"    :action="api_app.baseUrl+'/file/uploadfilebatch'"  :on-success="addImgSuccessHandle"  :show-file-list="false" >
                                               <div class="uploadIconBox"  slot="trigger"  @click="addImgClick('mianliaocanshu',list.imageJson[0].fabricParamImgs)"><i  class="el-icon-plus avatar-uploader-icon"></i></div>
                                            </el-upload>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div>
                                <el-button type="primary" @click="addOneFabric">新增面料 + </el-button>
                            </div>
                            <div>
                                <div>
                                    辅料 ：
                                    <span @click="toggleSelected(list)" class="btnSpan"  :class="{active:list.isSelect==1}" v-for="list in ruleForm.fabricInformationStrObj.excipient&&ruleForm.fabricInformationStrObj.excipient.list">{{list.dataName}}</span>
                                   <span class="inlineSpan">其他：</span>
                                   <el-input v-model="ruleForm.fabricInformationStrObj.excipient.other"></el-input>
                                </div>
                                <div>
                                    面辅料补充说明：
                                    <el-input type="textarea" v-model="ruleForm.fabricInformationStrObj.supplementInfo"></el-input>
                                </div>
                            
                            </div>
                        </div>
                       
                    </el-form-item>
                    <hr>
                    <el-form-item label="需要生产商制作" prop="desc">
                       <span class="btnSpan" @click="toggleSelected(list)" :class="{active:list.isSelect==1}" v-for="list in ruleForm.needProducerDoObj.list">{{list.dataName}}</span>
                       <span class="inlineSpan">其他：</span>
                       <el-input v-model="ruleForm.needProducerDoObj.other"></el-input>
                    </el-form-item>
                    <hr>
                    <el-form-item label="抢单截止日期" prop="orderTakingEndTime" required>
                        <el-date-picker  value-format="yyyy/MM/dd HH:mm:ss"  type="datetime" placeholder="选择日期" v-model="ruleForm.orderTakingEndTime" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <hr>
                    <el-form-item label="交货方式" >
                        <el-select v-model="ruleForm.deliveryMethod" placeholder="选择交货方式">
                            <el-option :label="list.text" :value="list.value" v-for="list in deliveryMethodWord"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="大货运费承担方" prop="highFreightChargeBearer" required>
                        <el-select v-model="ruleForm.highFreightChargeBearer" placeholder="请选择">
                            <el-option :label="list.text" :value="list.value" v-for="list in identifyWord"></el-option>

                        </el-select>
                    </el-form-item>
                    <hr>
                    <el-form-item label="联系方式" required >
                        <div>
                            <span class="margin10">{{ruleForm.contactInformationStrObj.address_contact_name}}</span>
                            <span class="margin10"> {{ruleForm.contactInformationStrObj.address_contact_phone}}</span>
                            <span class="margin10">{{ruleForm.contactInformationStrObj.address}}</span>
                            <el-button @click="toAddressList">获取地址列表</el-button>
                            <el-button @click="addAddress">添加新地址</el-button>
                        </div>
                        <div class="addressListsBox" v-loading="isLoadingAddress">
                            <div class="addressList" v-for="addressList in  fadanAddressLists"  :class="{active:addressList.address_id==contactMode}">
                                 <i class="el-icon-success choseAddressIcon"   @click="choseAddress(addressList)"></i>
                                 <span class="spanItem">{{addressList.address_contact_name}}</span>
                                 <span class="spanItem"> {{addressList.address_contact_phone}};</span>
                                 <span class="spanItem long">
                                    {{addressList.region_province_string}}
                                    {{addressList.region_city_string}}
                                    {{addressList.region_district_string}}
                                    {{addressList.address_string}}
                                    <span v-if="addressList.address_is_default=='y'" class="spanItem">(默认地址)</span>
                                 </span>
                                 <el-button size="mini" @click="editAddress(addressList)"><i class='el-icon-edit'></i></el-button>
                                 <el-button size="mini" @click="deleteAddress(addressList)"><i class='el-icon-delete'></i></el-button>

                            </div>
                           
                        </div>
                    </el-form-item>
                    <hr>
                   <el-form-item label="订单支付信息" v-if="!isAllowEditPrice">
                       <div>
                            <div>
                               数量：{{ruleForm.orderQuantity}}件；单价：{{ruleForm.orderUnitPrice}}元；总价：{{orderTotalPrice}}元；
                           </div>
                           <div>
                               <span class="errorStar">*</span> 该意向价格是否含税：
                               {{ruleForm.payInfoStrObj.order_is_include_tax}}
                           </div>
                           <div>
                                <span class="errorStar">*</span>预付款:<span class="spanItem">{{orderAdvancePayment}} 元</span> 
                               {{ruleForm.payInfoStrObj.order_advance_payment_percent}} %
                           </div>
                           <div>
                                <span class="errorStar">*</span>交货款:<span class="spanItem">{{orderDeliveryPayment}}元</span> 
                                {{ruleForm.payInfoStrObj.order_delivery_payment_percent}}     %
                           </div>
                           <div>
                               尾款/质保金：<span class="spanItem">{{tailMoney}}元</span>   ({{tail_money_pecent}}%)
                           </div>
                       </div>
                      
                   </el-form-item>
                   <hr>
                    <el-form-item label="订单支付信息" v-if="isAllowEditPrice">
                        <el-button @click="isShowPayBlock=!isShowPayBlock"  >
                            <i class="el-icon-caret-bottom" v-if="isShowPayBlock">收起</i>
                            <i class="el-icon-caret-top" v-if="!isShowPayBlock">展开</i>
                        </el-button>
                        <div v-if="isShowPayBlock">
                             <div>
                                数量：{{ruleForm.orderQuantity}}件；单价：{{ruleForm.orderUnitPrice}}元；总价：{{orderTotalPrice}}元；
                            </div>
                            <div>
                                <span class="errorStar">*</span> 该意向价格是否含税：
                                <!-- <el-input v-model="ruleForm.payInfoStrObj.order_is_include_tax"></el-input> -->
                                <el-radio v-model="ruleForm.payInfoStrObj.order_is_include_tax" label="y">是</el-radio>
                                <el-radio v-model="ruleForm.payInfoStrObj.order_is_include_tax" label="n">否</el-radio>
                            </div>
                            <div>
                                 <span class="errorStar">*</span>预付款:<span class="spanItem">{{orderAdvancePayment}} 元 {{ruleForm.payInfoStrObj.order_advance_payment_percent}}</span> 
                                <el-input-number @change="computePercent_prev" @focus="focusPercent_prev" :min="0" :max="prevMoneyMax"   v-model="ruleForm.payInfoStrObj.order_advance_payment_percent"></el-input-number>%
                            </div>
                            <div>
                                <!-- @blur="computePercent" -->
                                 <span class="errorStar">*</span>交货款:<span class="spanItem">{{orderDeliveryPayment}}元 {{ruleForm.payInfoStrObj.order_delivery_payment_percent}}</span> 
                                <el-input-number @change="computePercent_deli" @focus="focusPercent_deli" :min="0" :max="deliMoneyMax"  v-model="ruleForm.payInfoStrObj.order_delivery_payment_percent"></el-input-number>%
                            </div>
                            <div>
                                尾款/质保金：<span class="spanItem">{{tailMoney}}元</span>   ({{tail_money_pecent}}%)
                                 <span class="red" v-if="tail_money_pecent<0"> 预付款和交货款之和不能大于100</span>
                            </div>
                        </div>
                       
                    </el-form-item>
                    <hr>
                    <el-form-item label="优先推送" prop="desc">
                        <div class="userPushWrap">
                            <div class="">
                                <el-button @click="openProducerListsModal">打开生产商列表</el-button>
                            </div>
                            <div class="userPushListsBox">
                                <div class="span">当前推送的生产商:</div>
                                <ul class="producerListsBox">
                                    <li v-if="orderPushProducerLists.length==0">暂无推送</li>
                                    <li class="producerItem listBLi" v-for="(listProducer,index) in orderPushProducerLists" >
                                      <span class="spanItem long">{{listProducer.company_name}}  </span>
                                      <!-- <span class="spanItem">userId：{{listProducer.user_id}}</span> -->
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-form-item>
                    <hr>
                    <el-form-item label="意向订单备注" prop="desc">
                        <el-input type="textarea" v-model="ruleForm.intentionalOrderRemark"></el-input>
                    </el-form-item>
                    <hr>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">提交修改</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <addAddressModal ref="addressModal" @submitSuccessFun="getAddressLists"  :type="addressModalType" :editId="currentEditAddressId" :isShow="isShowAddAddress" :userId="fadanUserId" @closeModal="closeAddAddressModal"></addAddressModal>
        <producerListsModal ref="producerListsModal" :hadChosedArr="orderPushProducerLists" :isShow="isShowProducerListsModal" @submitSuccessFun="chosePushProducer"   @close="isShowProducerListsModal=false"></producerListsModal>

    </div>
</template>

<script>
    import {        json,        wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,        api    } from '@/common/request.js'
    import {        ajaxApp,        api_app    } from '@/common/request_app.js'
    import addAddressModal from '@/components/addAddressModal.vue'
    import producerListsModal from '@/components/producerListsModal.vue'
    export default {
        name: 'addOrder',
        data() {
             var checkUnitPrice = (rule, value, callback) => {
               if (!value) {
                 return callback(new Error('单价不能为空'));
               }
               setTimeout(() => {
                 if (isNaN(value)) {
                   callback(new Error('请输入数字值'));
                 } else {
                   if (value <= 0) {
                     callback(new Error('必须大于0'));
                   } else {
                     callback();
                   }
                 }
               }, 300);
             };
            return {
                prevMoneyMax:100,
                deliMoneyMax:100,
                producerLists:[],//所有生产商列表
                orderPushProducerLists:[],//当前已经推送的展示的
                isShowProducerListsModal:false,
                fabricMainWord:[],
                isLoadingAddress:false,
                isShowAddAddress:false,//地址组件相关
                addressModalType:'',//add edit
                currentEditAddressId:"",
                isloading:false,
                contactMode:'',//地址id
                uploadData:{},
                currentImgClickArr:[],
                isShowFabricBlock:true,
                isShowPayBlock:true,
                isShowSizeBlock:true,
                orderNumber:'',
                orderStatus:'',
                fadanfangInfo:{
                    fadanfangInfo:{}
                },
                fadanAddressLists:[],
                imageType:'',//上传图片传的参数
                orderType:'',
                fadanUserId:'',
                user_cellphone:'',
                identifyWord:[{
                  text:"发单方",
                  value:"发单方"
                },{
                    text:"接单方",
                    value:"接单方"
                }],
                brandWord: [],
                quantityStrWord: [],
                deliveryMethodWord:[],
                faceAccessoriesWord:[],
                styleWord1: [],
                styleWord2: [],
                styleWord3: [],
                sizeTypeWord:[
                    {
                        text:"常规尺码",
                        value:"10202"
                       
                    },{
                        text:"裤装尺码",
                        value: "10203"
                       
                    },{
                        text:"童装尺码",
                        value: "10204"
                       
                    }
                ],
                regularSizeWord:[],
                pantsSizeWord:[],
                childSizeWord:[],
                currentSizeArr:[],
                currentSizeGroup:[],
                positiveImgArr:[],
                negativeImgArr:[],
                detailsImgArr:[],
                ruleForm: {
                    orderBand:'',
                    quantityStr:'',
                    contactInformationStrObj:'',
                    orderDeliveryTime:'',
                    orderTakingEndTime:"",
                    orderUnitPrice:'',
                    orderQuantity:'',
                    highFreightChargeBearer:'',
                    deliveryMethod:'',
                    needInfomationObj:{},
                    needProducerDoObj:{},
                    colorSizeQuantityStrObj:{},
                    fabricInformationStrObj:{
                        excipient:{
                            list:[],
                            other:{}
                        },
                        group:[]
                    },
                    payInfoStrObj:{},
                    styleDes:'',
                    sizeType:'',
                    style1:"",
                    style2:"",
                    style3: '',
                    intentionalOrderRemark:'',
                },
                rules: {
                    orderBand: [
                        { required: true, message: '请选择品牌', trigger: 'blur' }
                    ],
                    orderUnitPrice: [
                        { validator: checkUnitPrice, trigger: 'blur' }
                    ]
                }
            }
        },
        computed:{
            yjjToken(){
              return utils.getToken_Yjj()  
            },
            isAllowEditPrice(){
                if(this.orderStatus==10100||this.orderStatus==10200){
                    return true
                }else{
                    return false
                }
            },
            api_app(){
                return api_app  
            },
            IMG_PREV(){
            	return api.imgPrev
            },
            orderTotalPrice:function(){//总价
                let result=parseFloat(this.ruleForm.orderUnitPrice) * parseFloat(this.ruleForm.orderQuantity)
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                }
            },
            tail_money_pecent:function(){
                let result=100-this.ruleForm.payInfoStrObj.order_advance_payment_percent-this.ruleForm.payInfoStrObj.order_delivery_payment_percent
                 if(isNaN(result)){
                     return '-'
                 }else{
                     return result.toFixed(2)
                 } 
            },
            orderAdvancePayment:function(){
                let result=this.orderTotalPrice*this.ruleForm.payInfoStrObj.order_advance_payment_percent/100
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                }
            },
            orderDeliveryPayment:function(){
                let result=this.orderTotalPrice*this.ruleForm.payInfoStrObj.order_delivery_payment_percent/100
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                }
            },
            tailMoney:function(){
                let result=this.orderTotalPrice*this.tail_money_pecent/100
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                }
            },
        },
        components: {
        	addAddressModal,producerListsModal
        },
        methods: {
             changeOrderUnitPrice(){
                let _this=this
                let val=this.ruleForm.orderUnitPrice
                if(!isNaN(val)&&val<0 ){
                    _this.ruleForm.orderUnitPrice=Number(val.substring(1)).toFixed(2)
                }
                if(!isNaN(val)&&val>0){
                     _this.ruleForm.orderUnitPrice=Number(val).toFixed(2)
                }
                
            },
            focusPercent_prev(){
                console.log('预付款获取焦点,设置最大为100')
                this.prevMoneyMax=100
                
            },
            focusPercent_deli(){
                console.log('交货款获取焦点,设置最大为100')
                this.deliMoneyMax=100
            },
            computePercent_prev(val){
                console.log(val,'change预付款')
                if(val==100){
                    this.ruleForm.payInfoStrObj.order_delivery_payment_percent=0 
                }else{
                    this.prevMoneyMax=100-this.ruleForm.payInfoStrObj.order_delivery_payment_percent
                    this.deliMoneyMax=100-val
                }
                
            },
            computePercent_deli(val){
                console.log(val,'change交货款')
                if(val==100){
                    this.ruleForm.payInfoStrObj.order_advance_payment_percent=0 
                }else{
                    this.deliMoneyMax=100-this.ruleForm.payInfoStrObj.order_advance_payment_percent
                    this.prevMoneyMax=100-val
                }
            },
            toOrderList(){
                this.$router.push('/orderList')
            },
            chosePushProducer(producerLists){
                let _this=this
                console.log("modal里面选择完成了，现在开始重置页面的数据")
                this.orderPushProducerLists=[]
                producerLists.forEach(function(item,index){
                    if(item.isChosed==1){
                        let buffer={}
                        buffer.user_id=item.user_id
                        buffer.company_name=item.company_name
                        _this.orderPushProducerLists.push(buffer)
                    }
                })
            },
            openProducerListsModal(){
                this.isShowProducerListsModal=true
                this.$refs.producerListsModal.resetProducerLists()
            },
            deleteAddress(list){
                let _this = this
                let arg = {
                	addressId: list.address_id,
                }
                ajaxApp('/yijiajiaUserAddress/delUserAddress', arg).then(function(res) {
                     _this.$message({
                        message: res.errorMsg,
                        type: 'success',
                        duration: 1000
                    });
                    _this.getAddressLists()
                }, function(res) {})
                
            },
            deleteFabricGroup(index){
                this.ruleForm.fabricInformationStrObj.group.splice(index,1)
            },
            addOneFabric() {
                //fabricInformationStrObj  
                let buffer = {
                    name: "",
                    nominatedSupplier:"",
                    fabricMainRadio: "",
                    fabricMainEdit: "", //fabricMain
                    fabricMainSelect: "",  //fabricMain
                    fabricGramWeight:"",
                    recombination: "",
                    shrink: "",
                    washing: "",
                    imageJson: [{
                        fabricImgs: [],
                        fabricParamImgs: []
                    }],
                }
                this.ruleForm.fabricInformationStrObj.group.push(buffer)
            },
            closeAddAddressModal(){
                console.log(6666666)
                 this.isShowAddAddress=false
            },
            addAddress(){
                this.isShowAddAddress=true
                this.addressModalType='add'
                this.currentEditAddressId=""
                 this.$refs.addressModal.initAddressModal();
            },
            editAddress(list){
              console.log(list)  
              this.isShowAddAddress=true
              this.addressModalType='edit'
              this.currentEditAddressId=list.address_id
              this.$refs.addressModal.getDetailById(this.currentEditAddressId);

            },
            choseAddress(list){
                this.contactMode=list.address_id
                this.ruleForm.contactInformationStrObj={
                    address:list.region_province_string+list.region_city_string+list.region_district_string+list.address_string,
                    address_contact_name:list.address_contact_name,
                    address_contact_phone:list.address_contact_phone
                }
            },
            toAddressList(){
                this.getAddressLists()
            },
            getAddressLists() {
            	let _this = this
            	let arg = {
            		userId: _this.fadanUserId
            	}
                this.isLoadingAddress=true
                ajaxApp('/yijiajiaUserAddress/requestUserAddressList',arg).then(function(res){
                    setTimeout(function(){
                        _this.isLoadingAddress=false
                    },500)
                     
                    if(res.errorCode==200){
                         _this.fadanAddressLists=JSON.parse(JSON.stringify(res.data)) 
                    }
                   
                },function(res){
                })
            },
            deleteImg(index,arr){
                console.log(index)
               console.log(arr)  
               arr.splice(index,1)
            },
            addImgClick(type,arr){
                console.log(type,'当前点击的类型')
                let token=this.yjjToken
                if(type=='zheng'){
                    this.imageType=31101
                    this.uploadData={
                        imageType:this.imageType ,
                        imageUserId:this.fadanUserId, 
                        token:token,
                    }
                } 
                if(type=='fan'){
                    this.imageType=31201
                    this.uploadData={
                        imageType:this.imageType ,
                        imageUserId:this.fadanUserId, 
                        token:token,
                    }
                }
                if(type=='detail'){
                    this.imageType=31301
                    this.uploadData={
                        imageType:this.imageType ,
                        imageUserId:this.fadanUserId,
                        token:token,
                    }
                }
                if(type=='mianliao'){
                    this.imageType=32101
                    this.currentImgClickArr=arr
                    this.uploadData={
                        imageType:this.imageType ,
                        imageUserId:this.fadanUserId,
                        token:token,
                    }
                }
                if(type=='mianliaocanshu'){
                    this.imageType=32201
                    this.currentImgClickArr=arr
                    this.uploadData={
                        imageType:this.imageType ,
                        imageUserId:this.fadanUserId,
                        token:token,
                    }
                }
                
                
            },
            addImgSuccessHandle(res, file) {
                let _this=this
                if(res.errorCode==200){
                    let imageUrl = URL.createObjectURL(file.raw);
                    let resIdStr=res.data
                    let resIdArr=resIdStr.split(",")
                   _this.$message({
                        message: "上传成功", 
                        type: 'success',
                        duration: 1000
                   });
                    let buffer={
                        image_file:imageUrl,
                        imgIdArr:resIdArr,
                        isAdd:'y'
                    }
                     
                    if(_this.imageType==31101){
                        _this.positiveImgArr.push(buffer)
                    }
                    if(_this.imageType==31201){
                        _this.negativeImgArr.push(buffer)
                    }
                    if(_this.imageType==31301){
                        _this.detailsImgArr.push(buffer)
                    }
                    if(_this.imageType==32101){
                        _this.currentImgClickArr.push(buffer)
                    }
                     if(_this.imageType==32201){
                        _this.currentImgClickArr.push(buffer)
                    }
                   console.log( _this.currentImgClickArr,'当前点击的图片数组')
                    
                }else{
                    _this.$message({
                         message: "上传失败", 
                         type: 'error',
                         duration: 1000
                    });
                }
            },
            changeSizeNum(list){
                let _this=this
                console.log(list)
                list.sum=0
                list.sizeArr.forEach(function(item,index){
                    list.sum+=parseInt(item.number) 
                })
                //总数量
                _this.ruleForm.orderQuantity=0
                _this.currentSizeGroup.forEach(function(item,index){
                    _this.ruleForm.orderQuantity+=item.sum
                })
               
            },
            deleteColorGroup(index){
                this.currentSizeGroup.splice(index,1)
            },
            addColorGroup(){
                let childArr=[]
                this.currentSizeArr.forEach(function(item,index){
                    if(item.isSelect==1){
                        let temp={name: item.dataName,number: 0}
                        childArr.push(temp)
                    }
                })
                if(childArr.length>0){
                     let buffer={
                        color:"",
                        fold:false,
                        sum:0,
                        sizeArr:childArr
                    }
                    this.currentSizeGroup.push(buffer)
                }
               
                console.log( childArr,' childArr')
                console.log( this.currentSizeGroup,' this.currentSizeGroup')
            },
            toggleSelected(list,arg){//点击按钮active
                list.isSelect= list.isSelect==1?0:1
                if(arg=='sizeColor'){
                    this.currentSizeGroup=[]
                    this.addColorGroup()
                }
            },
            changeSizeType(){
                if(this.ruleForm.sizeType==10202){
                    this.currentSizeArr=this.regularSizeWord
                    console.log(this.currentSizeArr)
                }
                if(this.ruleForm.sizeType==10203){
                    this.currentSizeArr=this.pantsSizeWord
                }
                if(this.ruleForm.sizeType==10204){
                    this.currentSizeArr=this.childSizeWord
                }
                this.currentSizeGroup=[]
                
            },
            changeStyle(num, value) {
                let _this = this
                let arg = {
                    parentId: value
                }
                ajaxApp('/yijiajiaDataCategory/categoryInfo', arg).then(function(res) {
                    console.log(num, res.data)
                    if (res.errorCode === 200) {
                        if (num == 'default') {
                            _this.styleWord1 = res.data.map(function(item, index) {
                                return {
                                    text: item.category_name,
                                    value: item.category_id,
                                }
                            })
                            _this.styleWord2 = []
                            _this.styleWord3 = []
                            _this.ruleForm.style1 = ''
                            _this.ruleForm.style2 = ''
                            _this.ruleForm.style3 = ''
                        }
                        if (num == 1) {

                            _this.styleWord2 = res.data.map(function(item, index) {
                                return {
                                    text: item.category_name,
                                    value: item.category_id,
                                }
                            })
                            _this.styleWord3 = []
                            _this.ruleForm.style2 = ''
                            _this.ruleForm.style3 = ''
                        }
                        if (num == 2) {
                            _this.styleWord3 = res.data.map(function(item, index) {
                                return {
                                    text: item.category_name,
                                    value: item.category_id,
                                }
                            })
                            _this.ruleForm.style3 = ''
                        }

                    }
                }, function(res) {

                })
            },
            // 获取品牌数据
            getBrandData() {
                let _this = this
                let arg = {
                    userId:this.fadanUserId,
                }
                ajaxApp('/yijiajiaUserAuth/showUserAuthBrand', arg).then(function(res) {
                    if (res.errorCode === 200) {
                        _this.brandWord = []
                        let arr = res.data.companyBrand && res.data.companyBrand.split(',');
                        arr.forEach(function(item, index) {
                            let buffer = {
                                text: item,
                                value: item,
                            }
                            _this.brandWord.push(buffer)
                        })
                        console.log(_this.brandWord, '品牌')

                    }
                }, function(res) {

                })

            },

            // 获取初始数据
            getCategoryData() {
                let _this = this
                let arg = {
                    types: '10201,10202,10203,10204,10205,10206,10230,10231,10232,10233,10234,10236,10237'
                }
                ajaxApp('/yijiajiaDataCategory/getDatasource', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        //获取品质
                        _this.quantityStrWord = res.data.quantityStr.list.map((item, index) => {
                            return {
                                text: item.dataName,
                                value: item.dataName
                            }
                        })
                          //获取尺码
                        _this.regularSizeWord=res.data.regularSize.list 
                        _this.pantsSizeWord=res.data.pantsSize.list 
                        _this.childSizeWord=res.data.childSize.list 
                        //获取deliveryMethodWord
                        _this.deliveryMethodWord=res.data.deliveryMethod.list.map((item, index) => {
                            return {
                                label: item.dataName,
                                value: item.dataName,
                            }
                        })
                        //获取面辅料提供情况
                         _this.faceAccessoriesWord=res.data.faceAccessories.list.map((item, index) => {
                            return {
                                label: item.dataName,
                                value: item.dataName,
                            }
                        })
                         //获取面料信息：羊毛，亚麻等
                         _this.fabricMainWord=res.data.mainComponentFabric.list.map((item,index) =>{
                             return {
                                 label: item.dataName,
                                 value: item.dataName,
                             }
                         })
                        
                    }
                }, function(res) {

                })

            },
            getParam(){
            	this.orderNumber=this.$route.params.orderNumber
            	this.orderType=this.$route.params.orderType
            	this.fadanUserId=this.$route.params.fdUserId
            },
            getDetail_fabic(){//面辅料
                let _this=this
                let arg={
                    orderNumber:this.orderNumber,
                    orderType:this.orderType
                }
                ajaxPost('/admin/yijiajiaOrder/fabicInformation',arg).then(function(res){
                    if(res.data.fabricInformationStr){
                        _this.ruleForm.fabricInformationStrObj=JSON.parse(JSON.stringify(res.data.fabricInformationStr))	
                        _this.ruleForm.fabricInformationStrObj.group.forEach(function(item,index,array){
                             
                            //解析图片
                            if(!item.imageJson||item.imageJson.length==0||utils.isEmptyObject(item.imageJson[0])){
                                item.imageJson=[{
                                    fabricImgs:[],
                                    fabricParamImgs:[]
                                }]
                            }else{
                                let buffer=[{
                                    fabricImgs:[],
                                    fabricParamImgs:[]
                                }]
                                buffer[0].fabricImgs=item.imageJson[0].fabricImgs||[]
                                buffer[0].fabricParamImgs=item.imageJson[0].fabricParamImgs||[]
                                item.imageJson =buffer
                            }
                            //解析主面料
                             let itemCopy =  JSON.parse(JSON.stringify(item));
                            if(item.fabricMainRadio==1){
                                itemCopy.fabricMainSelect = item.fabricMain
                                _this.$set(array, index, itemCopy)
                            }
                            if(item.fabricMainRadio==0){
                                itemCopy.fabricMainEdit = item.fabricMain
                                _this.$set(array, index, itemCopy)
                            }
                           
                                
                        })
                    }
                   
                    console.log( _this.ruleForm.fabricInformationStrObj,"获取后的面辅料转化后的格式")
                },function(res){
                    
                })
            },
            getDetail_addition(){
                let _this=this
                let arg={
                    orderNumber:this.orderNumber,
                    orderType:this.orderType
                }
                ajaxPost('/admin/yijiajiaOrder/additionalMaterialsShow',arg).then(function(res){
                },function(res){
                    
                })
            },
            getDetail_info(){//大部分详情
                let _this=this
                _this.isLoading=true
                let arg={
                    orderNumber:this.orderNumber,
                    orderType:this.orderType
                }
                ajaxPost('/admin/yijiajiaOrder/orderDetailsShow',arg).then(function(res){
                    console.log("获取详情接口成功")
                    _this.isloading=false
                    _this.fadanfangInfo=res.data.fadanfangInfo?res.data.fadanfangInfo:{fadanfangInfo:{}}
                    _this.orderStatus=res.data.orderStatus
                    _this.user_cellphone=_this.fadanfangInfo.fadanfangInfo.user_cellphone
                    _this.contactMode=res.data.contactMode
                    _this.ruleForm.orderBand=res.data.orderBand
                    _this.ruleForm.quantityStr=res.data.quantityStr
                    _this.ruleForm.orderDeliveryTime=res.data.orderDeliveryTime
                    _this.ruleForm.contactInformationStrObj=res.data.contactInformationStr?res.data.contactInformationStr:{}
                    if(res.data.orderStyleMemo){
                        let styleArr=res.data.orderStyleMemo.split("-")
                        _this.ruleForm.style1=styleArr[0]
                        _this.ruleForm.style2=styleArr[1]
                        _this.ruleForm.style3=styleArr[2]
                    }
                   
                    _this.ruleForm.orderUnitPrice=res.data.orderUnitPrice
                    _this.orderTotalPrice=res.data.orderTotalPrice
                    _this.ruleForm.orderQuantity=res.data.orderQuantity
                    _this.ruleForm.highFreightChargeBearer=res.data.highFreightChargeBearer
                    _this.ruleForm.deliveryMethod=res.data.deliveryMethod
                    _this.ruleForm.styleDes=res.data.styleDes
                    _this.ruleForm.orderTakingEndTime=res.data.orderTakingEndTime
                    _this.ruleForm.needInfomationObj=res.data.needInfomation?JSON.parse(res.data.needInfomation):{}
                    _this.ruleForm.needProducerDoObj=res.data.needProducerDo?JSON.parse(res.data.needProducerDo):{}
                    _this.ruleForm.intentionalOrderRemark=res.data.intentionalOrderRemark
                    //尺码颜色
                    _this.ruleForm.colorSizeQuantityStrObj=res.data.colorSizeQuantityStr?JSON.parse(res.data.colorSizeQuantityStr):{}
                    console.log( _this.ruleForm.colorSizeQuantityStrObj," _this.ruleForm.colorSizeQuantityStr")
                    _this.ruleForm.sizeType=String(_this.ruleForm.colorSizeQuantityStrObj.selectSize.value)
                    _this.currentSizeArr=_this.ruleForm.colorSizeQuantityStrObj.selectSize.list
                    _this.currentSizeGroup=_this.ruleForm.colorSizeQuantityStrObj.group?_this.ruleForm.colorSizeQuantityStrObj.group:[]
                    _this.ruleForm.payInfoStrObj=res.data.payInfoStr?JSON.parse(res.data.payInfoStr):{}
                    if(res.data.imageJson){
                        console.log(JSON.parse(res.data.imageJson),'图片')
                        _this.positiveImgArr=JSON.parse(res.data.imageJson).positiveImg?JSON.parse(res.data.imageJson).positiveImg:[]
                        _this.negativeImgArr=JSON.parse(res.data.imageJson).negativeImg?JSON.parse(res.data.imageJson).negativeImg:[]
                        _this.detailsImgArr=JSON.parse(res.data.imageJson).detailsImg?JSON.parse(res.data.imageJson).detailsImg:[]
                    }
                    if(res.data.orderPushUserIdStr&&res.data.orderPushUserIdStr.producerList&&res.data.orderPushUserIdStr.producerList.length>0){
                        _this.orderPushProducerLists=JSON.parse(JSON.stringify(res.data.orderPushUserIdStr.producerList)) 
                    }
                    console.log(_this.ruleForm,'获取详情以后的_this.ruleForm') 
                },function(res){
                    _this.isloading=false
                    console.log("获取详情接口出错")
                })
             
            },
            getStrFromKey(key,wordArr){
                let result=""
                console.log(key,wordArr)
                wordArr.forEach(function(item,index){
                    if(item.value==key){
                        result=item.text
                    }
                })
                console.log(result,'result')
                return result
            },
            getStrFromStyleword(num,key){
                let result=""
                if( isNaN(parseFloat(key)) ){
                    result=key
                }else{
                    if(num==1){
                       this.styleWord1.forEach(function(item,index){
                           if(item.value==key){
                               result=item.text
                           }
                       })
                    }
                    if(num==2){
                       this.styleWord2.forEach(function(item,index){
                           if(item.value==key){
                               result=item.text
                           }
                       })
                    }
                     if(num==3){
                       this.styleWord3.forEach(function(item,index){
                           if(item.value==key){
                               result=item.text
                           }
                       })
                    }
                }
                return result
            },
            mapArrImgId(arr){
                
                if(arr){
                    let imageArr=[]
                     arr.forEach(function(item,index){
                        if(item.isAdd=='y'){
                            item.imgIdArr.forEach(function(item2,index2){
                                imageArr.push(JSON.parse(item2))
                            })
                        }else{
                            let obj={imgId:item.imgId}
                            imageArr.push(obj)
                        }
                    })
                    return imageArr
                    
                }else{
                    return null
                }
            },
            concatImgArr(){
                let _this=this
                let result=[]
                for(var i=0;i<arguments.length;i++){
                    var item=arguments[i]
                    if(item&&item.length>0){
                        result=result.concat(_this.mapArrImgId(item))
                    }
                }
                return result
                
            },
            submitForm(formName) {
                let _this=this
                this.$refs[formName].validate((valid) => {
                    console.log(_this.ruleForm,"ruleForm")
                    if (valid) {
                        let sizeStyleText=this.getStrFromKey(this.ruleForm.sizeType,this.sizeTypeWord)
                        let colorSizeObj={
                            "orderQuantity":_this.ruleForm.orderQuantity,
                            "groupQuantity":this.currentSizeGroup.length,
                            "group":this.currentSizeGroup,
                            "selectSize":{"label":sizeStyleText,"value":this.ruleForm.sizeType, "list":this.currentSizeArr},
                        }
                            //面辅料图片组装
                        let fabricInformationObj=JSON.parse(JSON.stringify(this.ruleForm.fabricInformationStrObj)) 
                        fabricInformationObj.group.forEach(function(item,index){
                            console.log(item,'group------------------submit')
                            item.imageJson=_this.concatImgArr(item.imageJson[0].fabricImgs,_this.mapArrImgId(item.imageJson[0].fabricParamImgs))
                              //组装主面料
                             if(item.fabricMainRadio==1){//1是选择，0是自填
                                 item.fabricMain=item.fabricMainSelect
                             }
                             if(item.fabricMainRadio==0){
                                 item.fabricMain=item.fabricMainEdit
                             }
                        })
                        //图片组装：正面，背面，详情  positiveImgArr:[],  negativeImgArr:[],  detailsImgArr:[],
                        let imageArr=[]
                        imageArr=_this.concatImgArr(this.positiveImgArr,this.negativeImgArr, this.detailsImgArr)
                        let needInfomationObj=this.ruleForm.needInfomationObj
                        let needProducerDoObj= this.ruleForm.needProducerDoObj
                        let orderPayInfoObj={
                            "orderIsIncludeTax":_this.ruleForm.payInfoStrObj.order_is_include_tax,
                            "orderAdvancePaymentPercent":_this.ruleForm.payInfoStrObj.order_advance_payment_percent,
                            "orderDeliveryPaymentPercent":_this.ruleForm.payInfoStrObj.order_delivery_payment_percent}
                        let styleStr=_this.getStrFromStyleword(1,_this.ruleForm.style1)+'-'+_this.getStrFromStyleword(2,_this.ruleForm.style2)+'-'+_this.getStrFromStyleword(3,_this.ruleForm.style3)
                       //验证
                        if(_this.positiveImgArr.length==0){
                           this.$message({message: "正面全览照片没有上传",type: 'error',duration: 1000});
                           return false
                        }
                        if(!colorSizeObj.groupQuantity>0){
                            this.$message({message: "至少选择一个尺码",type: 'error',duration: 1000});
                            return false
                        }
                        let isVerifySizeColor=true
                       _this.currentSizeGroup.forEach(function(item,index){
                            let orderIndex=index+1
                           if(!item.color){
                               isVerifySizeColor=false
                               _this.$message({message: '第'+orderIndex +"组"+"未填写颜色",type: 'error',duration: 1000});
                               return false
                           }
                           if(!item.sum>0){
                               isVerifySizeColor=false
                               _this.$message({message: '第'+orderIndex +"组"+"未选择数量",type: 'error',duration: 1000});
                               return false
                           }
                       })
                       if(!isVerifySizeColor){
                           return false
                       }
                       if(!orderPayInfoObj.orderIsIncludeTax){
                            _this.$message({message: "未选择支付信息是否含税",type: 'error',duration: 1000});
                           return false
                       }
                       if(!(parseInt(_this.tail_money_pecent)+parseInt(_this.ruleForm.payInfoStrObj.order_advance_payment_percent) 
                       + parseInt(_this.ruleForm.payInfoStrObj.order_delivery_payment_percent)==100) ){
                            _this.$message({message: "未正确选择付款的百分比",type: 'error',duration: 1000});
                           return false
                       }
                       if(_this.tail_money_pecent<0){
                            _this.$message({message: "预付款与交货款比例不能大于100",type: 'error',duration: 1500});
                           return false
                       }
                        if(!_this.contactMode){
                            _this.$message({
                               message: "未选择地址",
                               type: 'error',
                               duration: 1000
                           });
                           return false
                       }
                        //推送商家
                       let orderPushUserIdStr=''
                       if(_this.orderPushProducerLists.length>0){
                           let idArr=[]
                           _this.orderPushProducerLists.forEach(function(item,index){
                               let bufferId=item.user_id
                               idArr.push(bufferId)
                           })
                           orderPushUserIdStr=idArr.join(",")
                       }
                       
                       console.log("表单参数验证通过1")
                       if(!confirm("确认提交当前页面吗？")){
                           return false
                       }
                        _this.isloading=true
                       //组装参数
                        let args={
                            orderNumber:_this.orderNumber,
                            adminId:'1',
                            colorSizeQuantityStr: JSON.stringify(colorSizeObj),
                            contactMode: _this.contactMode,
                            deliveryMethod:_this.ruleForm.deliveryMethod,
                            fabricInformation: JSON.stringify(fabricInformationObj),
                            highFreightChargeBearer: _this.ruleForm.highFreightChargeBearer,
                            imageJson: JSON.stringify(imageArr),
                            intentionalOrderRemark: _this.ruleForm.intentionalOrderRemark,
                            needInfomation:  JSON.stringify(needInfomationObj),
                            needProducerDo:JSON.stringify(needProducerDoObj),
                            orderBand: _this.ruleForm.orderBand,
                            orderDeliveryTime: _this.ruleForm.orderDeliveryTime,
                            orderIsDraft: "y",
                            orderPayInfo: JSON.stringify(orderPayInfoObj),
                            orderPushUserId: orderPushUserIdStr,//1,311
                            orderStyleMemo: styleStr,
                            orderTakingEndTime: _this.ruleForm.orderTakingEndTime,
                            orderType: this.orderType,
                            orderUnitPrice: _this.ruleForm.orderUnitPrice,
                            phone: _this.user_cellphone,
                            quantityStr: _this.ruleForm.quantityStr,
                            styleDes: _this.ruleForm.styleDes,
                            userId: _this.fadanUserId
                        }
                        console.log(args,"args")
                        ajaxPost('/admin/yijiajiaOrder/updateOrder',args).then(function(res){
                            
                            if(res.errorCode==200){
                               // _this.$message({message: "修改成功",type: 'success',duration: 1000});
                               if(confirm("修改成功，是否返回订单列表？")){
                                   _this.toOrderList()
                               }
                               //刷新页面
                               setTimeout(function(){
                                   _this.getDetail_info()
                                  _this.getDetail_fabic()
                                  _this.getDetail_addition() 
                               },200)
                               
                            }else{
                                _this.$message({message:res.errorMsg,type: 'error',duration: 2000});

                            }
                        },function(res){
                             _this.isloading=false
                            _this.$message({message:res.errorMsg,type: 'error',duration: 2000});

                        })
                    } else {
                        console.log('error submit!!');
                        alert("表单没有填写完整或格式不正确")
                        return false;
                    }
                });
            },
        },
        mounted() {
            let _this = this
            //获取页面传参
            this.getParam()
            //获取选项
            _this.getBrandData()
            _this.getCategoryData()
            _this.changeStyle('default', 0) 
            //获取详情信息
            setTimeout(function(){
                _this.getDetail_info()
                _this.getDetail_fabic()
                _this.getDetail_addition()
            },500)
        }
    }
</script>

<style lang="scss">
   
</style>



// WEBPACK FOOTER //
// src/pages/order/editOem.vue